import { FunctionComponent } from "react";
import { useDropzone, DropzoneOptions, FileWithPath } from "react-dropzone";
import { Stack } from "@mui/material";
import { Trans } from "react-i18next";

import { classNames } from "@/utils/classNames";

export type File = FileWithPath;

interface FileDropzoneProps extends DropzoneOptions {
	caption?: string;
}

export const FileDropzone: FunctionComponent<FileDropzoneProps> = ({ caption, ...other }) => {
	const { getRootProps, getInputProps, isDragActive } = useDropzone(other);

	return (
		<div
			className={classNames(
				"flex flex-col cursor-pointer items-center justify-center border border-dashed border-border-light rounded-xl p-6",
				isDragActive ? "bg-tile-active" : "bg-divider"
			)}
			{...getRootProps()}
		>
			<input {...getInputProps()} />

			<Stack alignItems="center" spacing={2}>
				<div className="text-text-meta text-smd text-center">
					<Trans
						components={{
							underline: <span className="underline" />,
						}}
						i18nKey="modals.addAvatar.description"
					/>
				</div>

				{caption && <div className="text-text-meta text-xs text-center">{caption}</div>}
			</Stack>
		</div>
	);
};
